// src/helper/trimLeadingDisabledWeek.js

export default function trimLeadingDisabledWeek(data) {
	if (!Array.isArray(data) || data.length < 7) {
		return data;
	}

	// 1. перевіряємо, що 0..4 всі isDisabled === true
	const firstFiveDisabled = data.slice(0, 5).every(item => item && item.isDisabled === true);

	// далі нам потрібні елементи 5 і 6
	const day6 = data[5]; // index 5
	const day7 = data[6]; // index 6

	// без цих днів далі нема сенсу
	if (!firstFiveDisabled || !day6 || !day7) {
		return data;
	}

	// хелпер для взяття дня місяця з "YYYY-MM-DD"
	const getDay = d => {
		if (!d) return null;
		const parts = d.split("-");
		return parts.length === 3 ? parseInt(parts[2], 10) : null;
	};

	const isDay6Ok =
			day6.isDisabled === false &&
			day6.name === "Saturday" &&
			getDay(day6.date) === 1;

	const isDay7Ok =
			day7.isDisabled === false &&
			day7.name === "Sunday" &&
			getDay(day7.date) === 2;

	if (isDay6Ok && isDay7Ok) {
		// забираємо перші 7
		return data.slice(7);
	}

	return data;
}
